import React from 'react';
import styles from '../Header.module.scss';

import { StyledButton } from 'components/Buttons';

import { useHistory } from 'react-router-dom';
import { usePicklistPermissions, usePicklistDetailsSelector } from 'hooks/Picklist';
import { useAddBomActions } from 'hooks/AddBomToPicklist';
import { useManageLooseItemsActions } from 'hooks/ManageLooseItems';
import { useMobileViewport } from 'hooks/useMobileViewport';

import { ADD_BOM_TO_PICKLIST_PATH, MANAGE_LOOSE_ITEMS_PATH } from 'constants/routeConstants';

import { MenuButtons } from './MenuButtons';
import { AddPicklistItemsButton } from './AddItemsButton';

export const ManagementButtons = ({
  onEdit,
  onRemove,
  onStatusChange,
  onAddAssets,
  onAddAssembly
}) => {
  const history = useHistory();
  const isMobile = useMobileViewport();

  const { currentPicklist } = usePicklistDetailsSelector();
  const { isPicklistOpen, canAddItems, canChangePicklistStatus, shouldDisableStatusButton } =
    usePicklistPermissions();

  if (!canAddItems && isMobile) return null;

  const { setActivePicklistAction } = useAddBomActions();
  const { setEntityDataAction } = useManageLooseItemsActions();

  const handleAddBomClick = () => {
    setActivePicklistAction({ id: currentPicklist.id, name: currentPicklist.name });
    history.push(ADD_BOM_TO_PICKLIST_PATH);
  };

  const handleAddLooseItemsClick = () => {
    setEntityDataAction({
      locationLooseItemDetails: {},
      activeEntity: currentPicklist,
      isPicklist: true
    });
    history.push(MANAGE_LOOSE_ITEMS_PATH);
  };

  return (
    <div className={styles.management}>
      {canAddItems && (
        <AddPicklistItemsButton
          onAddAssets={onAddAssets}
          onAddLooseItems={handleAddLooseItemsClick}
          onAddBOM={handleAddBomClick}
          onAddAssembly={onAddAssembly}
        />
      )}

      {canChangePicklistStatus && (
        <StyledButton
          classes={styles.management__status_btn}
          label={isPicklistOpen ? 'Start delivery' : 'Complete'}
          onClick={onStatusChange}
          disabled={shouldDisableStatusButton}
        />
      )}

      {!isMobile && <MenuButtons onEdit={onEdit} onRemove={onRemove} />}
    </div>
  );
};
